import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

// make point not available
import { MakePointNotApplicablePageComponent } from '../pages/notApplicable.component';

// create new Point
import { NewPointPageComponent } from '../pages/new.component';
import { NewPointComponent } from '../components/new.component';
// point edit
import { PointEditPageComponent } from '../pages/edit.component';
import { PointEditComponent } from '../components/edit.component';
// point edit notes
import { PointEditNotesPageComponent } from '../pages/edit-notes.component';
import { PointEditNotesComponent } from '../components/edit-notes.component';

import { routedComponents, PointEditorRoutingModule } from './point-editor.routing';

import { SharedModule } from '../../shared.module';

@NgModule({
  imports: [CommonModule, SharedModule, PointEditorRoutingModule, FormsModule, ReactiveFormsModule],
  declarations: [
    routedComponents,
    MakePointNotApplicablePageComponent,
    NewPointPageComponent,
    NewPointComponent,
    PointEditPageComponent,
    PointEditComponent,
    PointEditNotesPageComponent,
    PointEditNotesComponent
  ]
})
export class PointEditorModule {}
